/* import __COLOCATED_TEMPLATE__ from './question-freeform.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import { or, empty } from '@ember/object/computed';
import Component from '@ember/component';
import { QuestionResponse } from '@square/dashboard-protos/models/squareup/feedbacksurveys/survey_response';
import { feature } from '@square/ember-features/macros';
let QuestionFreeform = (_dec = classNames('dashboard-survey-question', 'dashboard-survey-question-freeform'), _dec2 = empty('inputValue'), _dec3 = or('isInputEmpty', 'responseSubmitted'), _dec4 = feature('dashboard/new_feedback_surveys'), _dec5 = computed('question.questionPrompt', 'onHandleTranslation'), _dec6 = computed('newFeedbackSurveysEnabled', 'hideRemindMeLaterButton'), _dec(_class = (_class2 = class QuestionFreeform extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "inputValue", null);
    _defineProperty(this, "responseSubmitted", false);
    _initializerDefineProperty(this, "isInputEmpty", _descriptor, this);
    _initializerDefineProperty(this, "submitDisabled", _descriptor2, this);
    _defineProperty(this, "question", null);
    _defineProperty(this, "hideRemindMeLaterButton", false);
    _initializerDefineProperty(this, "newFeedbackSurveysEnabled", _descriptor3, this);
  }
  get questionPrompt() {
    return this.onHandleTranslation ? this.onHandleTranslation(this.question?.questionPrompt) : this.question?.questionPrompt;
  }
  get showRemindMeLaterButton() {
    return this.newFeedbackSurveysEnabled && !this.hideRemindMeLaterButton;
  }
  didReceiveAttrs() {
    super.didReceiveAttrs();
    if (this.question !== this._lastQuestion) {
      this.set('inputValue', null);
      this.set('responseSubmitted', false);
    }
    this._lastQuestion = this.question;
  }
  handleRemindMeLater() {
    this.remindMeLater();
  }
  submitResponse() {
    this.set('responseSubmitted', true);
    this.next?.(QuestionResponse.create({
      questionToken: this.question?.questionToken,
      questionPrompt: this.question?.questionPrompt,
      freeFormResponse: QuestionResponse.FreeFormResponse.create({
        textResponse: this.inputValue
      })
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isInputEmpty", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "submitDisabled", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "newFeedbackSurveysEnabled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "questionPrompt", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "questionPrompt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showRemindMeLaterButton", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "showRemindMeLaterButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleRemindMeLater", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "handleRemindMeLater"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "submitResponse", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "submitResponse"), _class2.prototype), _class2)) || _class);
export { QuestionFreeform as default };